<template>
  <div>
    <div>
      <div class="m-disabled-box" v-if="!enablePlaceOrder"></div>
      <div class="card card-margin">
        <h3 class="sub-title">Contact</h3>
        <b-row>
            <b-col class="ml-3">
              <p class="item-title mb-2">First Name</p>
              <b-input
                :value="orderContact.FirstName"
                @input.native="updateContact('FirstName', $event)"
                data-test="summary-pay-firstname"
              ></b-input>
              <m-error-text
                :val="orderContact.FirstName"
                :immediate="showError"
                :rules="['require']"
              />
            </b-col>
            <b-col class="col-1"> </b-col>
            <b-col class="mr-3">
              <p class="item-title mb-2">Last Name</p>
              <b-input
                :value="orderContact.LastName"
                @input.native="updateContact('LastName', $event)"
                data-test="summary-pay-lastname"
              ></b-input>
              <m-error-text
                :val="orderContact.LastName"
                :immediate="showError"
                :rules="['require']"
              />
            </b-col>
            
          </b-row>
        <b-col>
          <p class="item-title mb-2">Email Address</p>
          <b-input
            placeholder="name@domain.com"
            :value="orderContact.Email"
            @input.native="updateContact('Email', $event)"
            data-test="summary-pay-email"
          ></b-input>
          <m-error-text
            :val="orderContact.Email"
            :immediate="showError"
            :rules="['require', 'email']"
          />
          <p class="demo-price-block demo-price-text">
          Selected Quantity:
          <span data-test="summary-info-perPrice">{{
            order.TotalDesiredQty | numberFormat("", 0)
          }}</span>
        </p>
        <p class="demo-price-block demo-price-text">
          Order Total:
          <span data-test="summary-info-perPrice">{{
            order.TotalEstmCost | numberFormat
          }}</span>
        </p>
          <p class="item-title mb-2 mt-2">Company Name</p>
          <b-input
            v-model="orderContact.Company"
            data-test="summary-pay-company"
          ></b-input>
          <m-error-text
            :val="orderContact.Company"
            :immediate="showError"
            :rules="['require']"
          />
         
        </b-col>

        <div v-if="isCreditCard">

          <h3 class="sub-title">Credit Card Details</h3>

          <b-col class="list-name-input-container">
            <p class="item-title mb-2">Card Number</p>
            <b-input
              placeholder="0000 0000 0000 0000"
              :value="orderPayment.Number"
              @input.native="updatePayment('Number', $event)"
              data-test="summary-pay-cardNumber"
            ></b-input>
            <m-error-text
              :val="orderPayment.Number"
              :immediate="showError"
              :rules="['require', 'creditCard']"
            />
          </b-col>
          <b-row>
            <b-col class="ml-3">
              <p class="item-title mb-2 mt-2">Expiration Date</p>
            </b-col>

            <b-col class="col-1"> </b-col>
            <b-col class="mr-3">
              <!-- <b-col class="col-5" style="margin-left: 92px"> -->
              <p class="item-title mb-2 mt-2">Security Code</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="ml-3" style="display: flex">
              <b-select
                v-model="orderPayment.ExpiredMonth"
                :options="expiredMonth"
                class="expiration-select"
              ></b-select
              >
              <m-error-text
                :val="orderPayment.ExpiredMonth"
                :immediate="showError"
                :rules="['require']"
              />
              <span style="margin: 5px 5px">/</span>
              <b-select
                v-model="orderPayment.ExpiredYear"
                :options="expiredYear"
                class="expiration-select"
              ></b-select>
              <m-error-text
                :val="orderPayment.ExpiredYear"
                :immediate="showError"
                :rules="['require']"
              />
            </b-col>
            <b-col class="col-1"> </b-col>
            <b-col class="mr-3">
              <!-- <b-col class="col-5" style="margin-left: 92px"> -->
              <b-input
                placeholder="CVC"
                :value="orderPayment.SecurityCode"
                @input.native="updatePayment('SecurityCode', $event)"
                data-test="summary-pay-securityCode"
              ></b-input>
              <m-error-text
                :val="orderPayment.SecurityCode"
                :immediate="showError"
                :rules="['require']"
              />
            </b-col>
          </b-row>
          <b-col class="list-name-input-container">
            <p class="item-title mb-2 mt-2">Name on Card</p>
            <b-input
              placeholder="Enter Name"
              :value="orderPayment.HolderName"
              @input.native="updatePayment('HolderName', $event)"
              data-test="summary-pay-holderName"
            ></b-input>
            <m-error-text
              :val="orderPayment.HolderName"
              :immediate="showError"
              :rules="['require']"
            />
          </b-col>
          <b-col class="list-name-input-container">
            <p class="item-title mb-2 mt-2">Address</p>
            <b-input
              :value="orderPayment.AddressLine"
              @input.native="updatePayment('AddressLine', $event)"
              data-test="summary-pay-address"
            ></b-input>
            <m-error-text
              :val="orderPayment.AddressLine"
              :immediate="showError"
              :rules="['require']"
            />
          </b-col>
          <b-row>
            <b-col class="ml-3">
              <p class="item-title mb-2 mt-2">City</p>
              <b-input
                :value="orderPayment.City"
                @input.native="updatePayment('City', $event)"
                data-test="summary-pay-city"
              ></b-input>
              <m-error-text
                :val="orderPayment.City"
                :immediate="showError"
                :rules="['require']"
              />
            </b-col>
            <b-col class="col-1"> </b-col>
            <b-col class="mr-3">
              <p class="item-title mb-2">State</p>
              <b-form-select
                v-model="orderPayment.State"
                data-test="summary-pay-state"
              >
                <option
                  v-for="item in $store.state.geo.states"
                  :value="item.code"
                >
                  {{ item.code }}
                </option>
              </b-form-select>

              <m-error-text
                :val="orderPayment.State"
                :immediate="showError"
                :rules="['require']"
              />
            </b-col>
            
          </b-row>
          <b-row>
            <b-col class="ml-3">
              <p class="item-title mb-2 mt-2">Zip Code</p>
              <b-input
                placeholder="00000"
                :value="orderPayment.Zipcode"
                @input.native="updatePayment('Zipcode', $event)"
                data-test="summary-pay-zip"
              ></b-input>
              <m-error-text
                :val="orderPayment.Zipcode"
                :immediate="showError"
                :rules="['require', 'zip']"
              />
            </b-col>
            <b-col class="col-1"> </b-col>
            <b-col class="mr-3">
              <p class="item-title mb-2">Country</p>
              <b-form-select
                v-model="orderPayment.CountryCode"
                data-test="summary-pay-country"
              >
                <option value="US" checked>United States</option>
                <option value="CA">Canada</option>
              </b-form-select>
              <m-error-text
                :val="orderPayment.CountryCode"
                :immediate="showError"
                :rules="['require']"
              />
            </b-col>
            
            
          </b-row>
          
          
        </div>
        <!-- 
            <b-col class="list-name-input-container mt-3 mb-3">
              <b-form-checkbox class="item">
                By providing your card information, you allow SL360 to charge
                your card for future payments in accordance with their terms.
              </b-form-checkbox>
            </b-col> -->
      </div>
    </div>
  </div>
</template>

<script>
import MErrorText from "@/components/common/MerrorText";
export default {
  components: {
    MErrorText,
  },
  props: {
    isUi2: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      cardType: [
        {
          value: 10,
          text: "VISA",
        },
        {
          value: 20,
          text: "MasterCard",
        },
        {
          value: 30,
          text: "American Express",
        },
        {
          value: 40,
          text: "Discover",
        },
      ],
    };
  },
  watch: {},
  created() {},
  methods: {
    updateContact(key, e) {
      this.$store.commit("order/updateContactInformation", {
        key: key,
        val: e.target.value,
      });
    },
    updateOrderDesc(e) {
      this.$store.commit("order/updateContactInformation", {
        key: "OrderName",
        val: e.target.value,
      });
      this.$store.commit("summary/saveShowError", e.target.value==='');
    },
    updatePayment(key, e) {
      this.$store.commit("order/updatePaymentInformation", {
        key: key,
        val: e.target.value,
      });
      if (key === "Number") {
        this.setCardType(e.target.value);
      }
    },
    setCardType(val) {
      let n = Number(val.substr(0, 1));
      let type = 10;
      if (n === 3) {
        type = 30;
      } else if (n === 4) {
        type = 10;
      } else if (n === 5) {
        type = 20;
      } else if ((n === 6)) {
        type = 40;
      }
      this.$store.commit("order/updatePaymentInformation", {
        key: "CardType",
        val: type,
      });
    },
    updatePaymentExpirationDate(e) {
      let date = e.target.value.split("/");
      if (date[0] && date[0] !== "" && date[1] && date[1] !== "") {
        this.$store.commit("order/updatePaymentInformation", {
          key: "ExpiredMonth",
          val: date[0],
        });

        this.$store.commit("order/updatePaymentInformation", {
          key: "ExpiredYear",
          val: date[1],
        });
      }
    },
    updateOrderDesc(e) {
      console.log(orderContact);
      // this.$store.commit('order/saveKey', ['OrderDesc', e.target.value])
      this.$store.commit("order/updateContactInformation", {
        key: "OrderName",
        val: e.target.value,
      });
    },
  },
  computed: {
    order() {
      return this.$store.state.order;
    },
    orderContact() {
      return this.$store.state.order.OrderContactInformation || {};
    },
    orderPayment() {
      let paymentInfo = this.$store.state.order.OrderPaymentInformation || {};
      let currentYear = new Date().getFullYear()
      if(paymentInfo.ExpiredYear&&paymentInfo.ExpiredYear<currentYear)
        paymentInfo.ExpiredYear = currentYear
      return paymentInfo
    },
    showError() {
      return this.$store.getters["summary/showError"];
    },
    isCreditCard() {
      return this.$store.getters["order/isCreditCard"];
    },
    expiredYear() {
      let result = [];
      let now = new Date();
      let year = now.getFullYear();
      for (let i = 0; i <= 10; i++) {
        result.push(year + i);
      }
      return result;
    },
    expiredMonth() {
      return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    },
    enablePlaceOrder() {
      return this.$store.getters["site/enablePlaceOrder"];
    },
  },
};
</script>

<style scoped lang="scss">
.item {
  padding-top: 8px;
  font-size: 13px;
}
.item-title {
  padding-right: 0;
  margin-right: 0;
}
.list-name-container {
  margin-top: 16px;
  margin-left: 15px;
  font-weight: bold;
}
.demo-box {
  margin-left: 8px;
  margin-bottom: 0px;
  margin-top: 8px;
}
.card-margin {
  margin: 16px auto;
  padding-bottom: 16px;
}
.expiration-select{
  width: 80px;
}
.sub-title{
  margin-top: 16px;
  margin-left: 16px;
  font-weight: bold;
  font-size: 1rem;
}

.demo-price-block {
  margin-top: 16px;
}

.demo-price-text {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-right: 9px;
}
</style>





// WEBPACK FOOTER //
// src/components/summary/MPayment.vue